export default ($) => {

    function init() {
        _popup();
        /*_initMap();*/
        _initZipFormValid();
        _showroom();
    }

    function isStateName(state) {
        var states = ['alabama','alaska','american samoa','arizona','arkansas','california','colorado','connecticut','delaware','district of columbia','federated states of micronesia','florida','georgia','guam','hawaii','idaho','illinois','indiana','iowa','kansas','kentucky','louisiana','maine','marshall islands','maryland','massachusetts','michigan','minnesota','mississippi','missouri','montana','nebraska','nevada','new hampshire','new jersey','new mexico','new york','north carolina','north dakota','northern mariana islands','ohio','oklahoma','oregon','palau','pennsylvania','puerto rico','rhode island','south carolina','south dakota','tennessee','texas','utah','vermont','virgin island','virginia','washington','west virginia','wisconsin','wyoming','alberta', 'british columbia', 'manitoba', 'new brunswick', 'newfoundland and labrador', 'northwest territories', 'nova scotia', 'nunavut', 'ontario', 'prince edward island', 'quebec', 'saskatchewan', 'yukon territory'];
        if (states.indexOf(state.toLowerCase()) >= 0) {
            return true;
        }
        return false;
    }

    function isStateCode(code){
        var objRegExp = /^(AK|AL|AR|AZ|CA|CO|CT|DC|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NB|NC|ND|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)$/i;
        return objRegExp.test(code.toUpperCase());
    }

    function isValidPostalCode(postalCode, countryCode) {
        var postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
        switch (countryCode) {
            case "US":
                postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
                break;
            case "CA":
                postalCodeRegex = /^([A-Z][0-9][A-Z])(\s*)([0-9][A-Z][0-9])$/gmi;
                break;
        }
        return postalCodeRegex.test(postalCode);
    }
    function _initZipFormValid(){

        $('.find-block .form-inline.zip-serch').on('submit', function(e){
            $(".zip-serch .errors").remove()
            // validation code here
            var input = $(this).find("input[name*='zip-search']");
            var postal = input.val();
            if( isStateCode(postal) || isStateName(postal) || ( isValidPostalCode(postal,'US') || isValidPostalCode(postal,'CA') ) ){
                $(this).removeClass( "is-invalid" );
            }else{
                input.addClass('is-invalid');
                input.before( function() {
                    return '<div class="errors ca d-none">You Must Enter a Postal Code / Province</div><div class="errors us">You Must Enter a Zip Code / U.S. State</div>';
                });
                e.preventDefault();
            }
        });

        $(".find-block .zip-serch input[name*='zip-search']").on('blur change input', function(e){
            $(".zip-serch .errors").remove();
            var postal = $(this).val();
            if( isStateCode(postal) || isStateName(postal) || (isValidPostalCode(postal,'US') || isValidPostalCode(postal,'CA') ) ){
                $(this).removeClass( "is-invalid" );
            }else{
                $(this).addClass('is-invalid');
                $(this).before( function() {
                    return '<div class="errors ca d-none">You Must Enter a Postal Code / Province</div><div class="errors us">You Must Enter a Zip Code / U.S. State</div>';
                });
            }
        });
    }

    function _popup() {
        $('.dealer-about-carousel img').on("click", function () {
            $('#meatModal #meatModalImg').remove();
            $('#meatModal .embed-responsive').remove();
            if($(this).data('img') !== undefined){
                var img = ' <img src="' + $(this).data('img') + '" id="meatModalImg" width="100%">'
                $('#meatModal .modal-body').append(img);
            }
            if($(this).data('video') !== undefined){
                var video = '<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="'+$(this).data('video')+'?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" allowfullscreen></iframe></div>'
                $('#meatModal .modal-body').append(video);
            }
            $('#meatModal').modal({
                show: true
            })
        });

        // stop playing the youtube video when I close the modal
        $('#meatModal').on('hide.bs.modal', function (e) {
            // a poor man's stop video
            $('#meatModal #meatModalImg').remove();
            $('#meatModal .embed-responsive').remove();
        });
    }

    /*function new_map($el) {
        // var
        var $markers = $el.find('.marker');

        // vars
        var args = {
            zoom: 22,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            gestureHandling: 'none'
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function () {
            add_marker($(this), map);
        });

        // center map
        center_map(map);

        // return
        //return map;
    }

    function add_marker($marker, map) {
        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            title: $marker.attr('data-title')
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }
    }

    function _initMap(){
        $('.acf-map').each(function () {
            // create map
            // map = new_map($(this));
            new_map($(this));
        });
    }*/

    function _showroom() {
        $('.showrooms_list_trigger').click(function () {
            $('.showrooms_list').slideToggle('fast');
        });
    }

    init();
}